import { SalesOrder } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1230. 受注案件編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
  name: string;
  description: string;
  user_id: number;
  business_partner_id: number;
  agency_id?: number;
  person_in_charge?: string;
  billing_target_id: number;
  product_id: number;
  spot_amount?: number;
  spot_billing_date?: string;
  monthly_amount?: number;
  monthly_billing_start_date?: string;
  monthly_billing_end_date?: string;
  contract_start_date?: string;
  contract_end_date?: string;
  delivery_date?: string;
}

const updateSalesOrder = (props: Props): Promise<SalesOrder> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}`, props);
};

export const useUpdateSalesOrder = () => {
  return useMutation({
    mutationFn: updateSalesOrder
  });
};
